<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';
import { useInbox } from 'dashboard/composables/useInbox';
import BaseBubble from './Base.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const { inboxId } = useMessageContext();

const {
  isAFacebookInbox,
  isAnInstagramChannel,
  isATiktokChannel,
  isAWhatsAppChannel,
} = useInbox(inboxId.value);

// SiteUp V2 (F1.5): o aviso deixou de ser uma frase corrida — que se confundia
// com uma mensagem escrita pelo contato — e virou "título + ação" (decisão
// travada 2026-08-09). O título é o mesmo nos 5 canais; só a linha de ação
// muda. As chaves UNSUPPORTED_MESSAGE_* antigas seguem no i18n (57 idiomas)
// e não foram removidas nesta fatia.
const actionKey = computed(() => {
  if (isAFacebookInbox.value) return 'CONVERSATION.UNSUPPORTED.ACTION_FACEBOOK';
  if (isAnInstagramChannel.value)
    return 'CONVERSATION.UNSUPPORTED.ACTION_INSTAGRAM';
  if (isATiktokChannel.value) return 'CONVERSATION.UNSUPPORTED.ACTION_TIKTOK';
  if (isAWhatsAppChannel.value)
    return 'CONVERSATION.UNSUPPORTED.ACTION_WHATSAPP';
  return 'CONVERSATION.UNSUPPORTED.ACTION_DEFAULT';
});
</script>

<template>
  <BaseBubble class="px-3 py-2.5" data-bubble-name="unsupported">
    <div class="flex gap-2.5 items-center">
      <div
        class="flex justify-center items-center rounded-[var(--workspace-radius,10px)] size-[30px] shrink-0 bg-n-alpha-2 text-n-slate-11"
      >
        <Icon class="size-4" icon="i-ph-warning" />
      </div>
      <div class="flex flex-col min-w-0">
        <span
          class="font-display text-sm font-bold leading-tight tracking-tight text-n-slate-12"
        >
          {{ $t('CONVERSATION.UNSUPPORTED.TITLE') }}
        </span>
        <span class="text-xs leading-tight tracking-tight text-n-slate-11">
          {{ $t(actionKey) }}
        </span>
      </div>
    </div>
  </BaseBubble>
</template>
